import { createFileRoute, redirect } from '@tanstack/react-router';

import { getCurrentSession } from '../app/auth-state';
import { OPERATOR_ROLE } from '../modules/auth/domain/entities/session';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const session = getCurrentSession();
    if (session?.user.role === OPERATOR_ROLE) {
      throw redirect({ to: '/queue' });
    }
    throw redirect({ to: '/login' });
  },
});
